import staticData from '@/assets/js/_data'
import SearchService from '@/services/search'

import { mapGetters } from 'vuex'

// For easier reference
const TIMESTAMP_EPOCH = 't'

export default {
  data () {
    return {
      copiedText: '',
      highlightsLoaded: false,
      highlightsLoading: false,
      fetchedHighlights: {},
      isEmptyPopover: false
    }
  },
  created () {
    if (
      this.lastClickedResult &&
      this.lastClickedResult.id &&
      this.lastClickedResult.id === this.resultId
    ) {
      this.classes.push('highlight-background--delayed')
    }
  },
  methods: {
    setIsEmptyPopover (isEmpty) {
      this.isEmptyPopover = isEmpty
    },
    fetchHighlights () {
      if (this.highlightsLoaded || this.highlightsLoading) return

      this.highlightsLoading = true
      SearchService.highlights(this.getSearchQueryForHighlighting(this.index, this.result.data.slug_values, this.$route.query.keyword)).then(highlights => {
        this.fetchedHighlights = highlights || {}
        this.highlightsLoaded = true
        this.highlightsLoading = false
      }).catch(err => {
        this.highlightsLoading = false
        this.error = this.handleError(err)
      })
    },
    linkToResult (e, routeName) {
      // Check if user clicked a real a href or virtual redirect by click on card
      if (e && e.target && e.target.href) return
      if (this.isEmpty(window.getSelection().toString())) {
        this.redirectToResult(e)
      } else {
        if (this.copiedText === window.getSelection().toString()) this.redirectToResult(e)
        this.copiedText = window.getSelection().toString()
      }
    },
    redirectToResult (e) {
      if (e.ctrlKey || e.metaKey) {
        window.open(this.$router.resolve(this.getRoute).href, '_blank')
      } else {
        this.$router.push(this.getRoute)
      }
    },
    redirectMiddleClick (e) {
      if (e && e.target && e.target.href) return
      window.open(this.$router.resolve(this.getRoute).href, '_blank')
    }
  },
  computed: {
    ...mapGetters({
      lastClickedResult: 'search/lastClickedResult'
    }),
    // This is a temporary computed property. It maps the slug_values to slug when applicable for List/Block results from search
    // Over time, once all indexes are via Flask, we can use the correct values immediatly.
    resultId () {
      return this.singularizeIndex(this.index) + '-' + this.parsedResultData.slug // get id of selected result
    },
    parsedResultData () {
      if (this.result.data && this.result.data.slug_values) {
        return {
          ...this.result.data,
          slug: this.result.data.slug_values[0]
        }
      }
      return this.result.data
    },
    cleanedIndex () {
      return this.$options.filters.humanize(this.$options.filters.singularize(this.index), '')
    },
    getQuery () {
      let obj = {}
      obj[`${this.singularizeIndex(this.index)}`] = this.parsedResultData.slug
      // Append human readable slug to the url query
      if (this.parsedResultData.slug_text) obj.hr = this.parsedResultData.slug_text

      const f = Object.assign({}, this.$route.query, obj)
      return f
    },
    getRoute () {
      return staticData.search_modals.includes(this.singularizeIndex(this.index))
        ? { name: this.$route.name, params: this.$route.params, query: this.getQuery }
        : { name: `${this.singularizeIndex(this.index)}.show`, params: { id: this.parsedResultData.slug } }
    },
    computedHighlights () {
      return {
        ...this.result.highlights,
        ...this.fetchedHighlights
      }
    },
    isNew () {
      // Is this result newer than the timestamp in the URL? (used for Alerts/Saved searches)
      if (
        this.$route.query &&
        this.$route.query[TIMESTAMP_EPOCH] &&
        this.result && this.result.data
      ) {
        return this.result.data.created_at_epoch > this.$route.query[TIMESTAMP_EPOCH]
      }
      return false
    },
    isOutOfBusiness () {
      // TODO: Temporarily, nothing is out of business!
      return false
      // Similar to the isNew boolean, this checks whether or not an organisation is out of business
      // return this.result?.data?.out_of_business
    },
    matches () {
      return this.result.matches.sort((a, b) => a.order - b.order)
    },
    hasPopover () {
      if (this.index === 'news') return false
      return true
    }
  }
}
